import type React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router";
import { RequireAuth, SignInPage } from "./base";
import { V2Layout } from "./components/layout/V2Layout";
import { ReferenceFilesRoutes as V2ReferenceFilesRoutes } from "./features/references";
import { rootRoute as R } from "./routes";
import { V2Routes } from "./v2/V2Routes";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={R.signIn.$path()} element={<SignInPage />} />
      <Route path={R.signedOut.$path()} element={<Navigate to={R.signIn.$buildPath({})} replace />} />

      {/* Reference-file image viewer — standalone popup window, no app chrome. */}
      <Route
        element={
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        }
      >
        <Route path="reference-files/*" element={<V2ReferenceFilesRoutes />} />
      </Route>

      {/* V2 — Dewey design system. Served at the application root. */}
      <Route
        element={
          <RequireAuth>
            <V2Layout />
          </RequireAuth>
        }
      >
        <Route path="*" element={<V2Routes />} />
      </Route>
    </Routes>
  );
};
